import { Link } from "react-router-dom";

export default function CTA() {
  return (
    <section id="cta" className="cta" style={{ padding: "80px 0", background: "linear-gradient(135deg, #0070f3 0%, #0050c8 100%)", textAlign: "center" }}>
      <div className="container" data-aos="zoom-in">
        <h2 style={{ color: "#fff", fontSize: "2.2rem", fontWeight: "700", marginBottom: "15px" }}>
          Ready to Transform Your Business with Technology?
        </h2>
        <p style={{ color: "rgba(255,255,255,0.85)", fontSize: "1.1rem", maxWidth: "650px", margin: "0 auto 30px" }}>
          Let us discuss your project requirements. Our team will analyze your needs and provide a customized solution proposal — completely free of charge and with no obligation.
        </p>
        <div>
          <Link
            to="/contact"
            className="btn"
            style={{
              background: "#fff",
              color: "#0070f3",
              padding: "14px 40px",
              borderRadius: "50px",
              fontWeight: "600",
              fontSize: "1rem",
              marginRight: "15px",
              transition: "all 0.3s ease",
            }}
          >
            Get Free Consultation <i className="bi bi-arrow-right ms-2" />
          </Link>
          <a
            href="https://wa.me/917000191398"
            target="_blank"
            rel="noreferrer"
            className="btn"
            style={{
              background: "transparent",
              color: "#fff",
              padding: "14px 40px",
              borderRadius: "50px",
              fontWeight: "600",
              fontSize: "1rem",
              border: "2px solid #fff",
            }}
          >
            <i className="bi bi-whatsapp me-2" /> WhatsApp Us
          </a>
        </div>
      </div>
    </section>
  );
}